import styled from '@emotion/styled'
import React from 'react';

type WithChildren<T = {}> = 
T & { children?: React.ReactNode };

const Content = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export function HorizontalFlex({ children }: WithChildren){
  return (
        <Content>
            {children}
        </Content>
  );
}
